import { useState, useEffect } from "react";
import {
  TextField,
  Grid,
  InputLabel,
  Select,
  FormControl,
  MenuItem,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setDialog, resetForm, Cards } from "../../../../app/slices/cardsSlice";
import { Controller, useForm } from "react-hook-form";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  HiOutlineCreditCard,
  HiOutlineIdentification,
  HiOutlineCalendarDays,
} from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const CardForm = () => {
  const [loading, setLoading] = useState(false);

  const _Card = useSelector((state) => state.cards.card);

  const isAdd = _Card.form.id ? false : true;
  const { control, reset, handleSubmit, setValue } = useForm({
    defaultValues: _Card.form,
  });

  const onSubmit = (data) => {
    if (isAdd) {
      setLoading(true);
      dispatch(Cards.create(data))
        .then(() => setLoading(false))
        .catch(() => setLoading(false));
    } else {
      setLoading(true);
      dispatch(Cards.update(_Card.form.id, data))
        .then(() => setLoading(false))
        .catch(() => setLoading(false));
    }
  };

  useEffect(() => {
    reset({ ..._Card.form });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_Card.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dispatch = useDispatch();

  const handleDialog = () => {
    dispatch(setDialog());
  };

  return (
    <FormDialog
      open={_Card.dialog}
      onClose={() => {
        handleDialog();
      }}
      maxWidth="sm"
      icon={<HiOutlineCreditCard />}
      title={isAdd ? "إضافة بطاقة جديدة" : "تعديل البطاقة"}
      subtitle={
        isAdd
          ? "أدخل معلومات البطاقة لإضافتها"
          : "قم بتحديث معلومات البطاقة ثم احفظ التغييرات"
      }
      onSubmit={handleSubmit(onSubmit)}
      saving={loading ? true : false}
      loading={_Card.loading}
    >
      <SectionCard icon={<HiOutlineIdentification />} title="معلومات البطاقة">
        <Grid item xs={12}>
          <Controller
            name="holder_name"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="اسم صاحب البطاقة"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="type"
            control={control}
            render={({ field }) => (
              <FormControl fullWidth size="small">
                <InputLabel>نوع البطاقة</InputLabel>
                <Select
                  value={field.value}
                  fullWidth
                  label="نوع البطاقة"
                  onChange={(e, newValue) => setValue("type", newValue)}
                  {...field}
                >
                  <MenuItem value="master">Master Card</MenuItem>
                  <MenuItem value="visa">Visa Card</MenuItem>
                </Select>
              </FormControl>
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="number"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="رقم البطاقة"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>

      <SectionCard icon={<HiOutlineCalendarDays />} title="معلومات الإصدار">
        <Grid item xs={12} sm={6}>
          <Controller
            name="order_issued_id"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="رقم طلب الاصدار"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Controller
              name="issued_at"
              control={control}
              render={({ field }) => (
                <DatePicker
                  inputFormat="YYYY-MM-DD"
                  label="تاريخ الاصدار"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      fullWidth
                      required
                    />
                  )}
                  {...field}
                  onChange={(newValue) => {
                    field.onChange(dayjs(newValue).format("YYYY-MM-DD"));
                  }}
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default CardForm;
